// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oCFz","left":"styles_left__1R_s7","desktopActions":"styles_desktopActions__2tzMg","title":"styles_title__1g3MJ"};